import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { VehicleDamageStatusEnum } from '../enums/vehicle-damage-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function vehicleDamageStatusToColor(
	status: VehicleDamageStatusEnum,
): string {
	switch (status) {
		case VehicleDamageStatusEnum.PENDING:
			return RecordColorEnum.AMBER;

		case VehicleDamageStatusEnum.REPAIRED:
			return RecordColorEnum.BLUE;

		case VehicleDamageStatusEnum.IGNORED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
